import { render, staticRenderFns } from "./getDispatchpersonnel.vue?vue&type=template&id=b3b8df62&scoped=true&"
import script from "./getDispatchpersonnel.vue?vue&type=script&lang=js&"
export * from "./getDispatchpersonnel.vue?vue&type=script&lang=js&"
import style0 from "./getDispatchpersonnel.vue?vue&type=style&index=0&id=b3b8df62&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b8df62",
  null
  
)

export default component.exports